"use client";

import { ErrorCard } from "@/components/ui/ErrorCard";

type ErrorProps = { error: Error & { digest?: string }; reset: () => void };

export default function Error(props: ErrorProps) {
  return (
    <ErrorCard
      {...props}
      heading="Registrierung nicht verfügbar"
      message="Beim Laden der Registrierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
      logPrefix="registrieren"
    />
  );
}
